import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import Side from "../../../components/journal/admin/detail/side";

import * as func from "../../../utils/functions";

import * as Actions from "../../../store/modules/journals";
import JAContent from "../../../components/journal/admin/detail/Jcontent";

class Journal extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="container-fluid mt-3 detail-wrap">
				<div className="row">
					<JAContent />
					{this.props.showSide !== 'false' &&
					<div className="sidebar-list xhide">
						<Side/>
					</div>
					}
				</div>
			</div>
		)
	}
}

export default connect(
	(state) => ({
		showSide : state.journals.showSide  ? state.journals.showSide  : 'true'
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Journal)

Journal.propTypes = {
	activeTab: PropTypes.number
};
